module.exports = __webpack_public_path__ + "img/yellow-circle.62d38dc4.svg";